<div class="row justify-content-center">
  <div class="col-lg-6">
    <div class="block border my-2">
      <div class="border-bottom p-2">
        <h4>Overview</h4><br/>
        Total deals: {{ totalDeals() }} <br/>
        Total unique deals: {{ totalUniqDeals() }} <br/>

        Total invested:  {{ totalInvested() }} <br/>
        Last created deal:  {{ lastCreatedDeal() }} <br/>

        Total profit deals:  {{ totalProfitDeals() }} <br/>
        Total profit: {{ totalProfit() }} <br/>

        Total loss deals:  {{ totalLossDeals() }} <br/>
        Total loss:  {{ totalLoss() }} <br/>

      </div>
    </div>
  </div>
</div>
